import { SortMeta } from 'primeng/api';

export function isSortMeta(obj: unknown): obj is SortMeta {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'field' in obj &&
    'order' in obj &&
    typeof (obj as SortMeta).field === 'string' &&
    typeof (obj as SortMeta).order === 'number'
  );
}
